import { TorneoTipo, TorneoTipoJSON } from '../TorneoTipo/TorneoTipo';
import { Partido, PartidoJSON } from '../Partido/Partido';
import { Torneo, TorneoJSON } from '../Torneo/Torneo';
import { TorneoZonaXFaseJSON, TorneoZonaXFase } from '../TorneoZonaXFase/TorneoZonaXFase';
export interface FaseJSON {
  fase_id: string;
  fase_torid: string;
  fase_ttid: string;
  fase_cant_max_equipos: number;
  fase_cant_zonas: number;
  fase_nombre: string;
  fase_orden: number;
  torneoTipo: TorneoTipoJSON | null;
  torneo: TorneoJSON | null;
  partidoList: PartidoJSON[];
  zonas: TorneoZonaXFaseJSON[];
}

export class Fase {
  protected constructor(
    private id: string,
    private torid: string,
    private ttid: string,
    private cantMaxEquipos: number,
    private cantZonas: number,
    private nombre: string,
    private orden: number,
    private torneoTipo: TorneoTipo,
    private torneo: Torneo | null,
    private partidoList: Partido[],
    private zonas: TorneoZonaXFase[]
  ) {}

  static createFrom(
    id: string,
    torid: string,
    ttid: string,
    cantMaxEquipos: number,
    cantZonas: number,
    nombre: string,
    orden: number,

    torneoTipo: TorneoTipo,
    torneo: Torneo | null,
    partidoList: Partido[],
    zonas: TorneoZonaXFase[]
  ) {
    return new this(
      id,
      torid,
      ttid,
      cantMaxEquipos,
      cantZonas,
      nombre,
      orden,
      torneoTipo,
      torneo,
      partidoList,
      zonas
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Fase) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: FaseJSON): Fase {
    return Fase.createFrom(
      entity.fase_id,
      entity.fase_torid,
      entity.fase_ttid,
      entity.fase_cant_max_equipos,
      entity.fase_cant_zonas,
      entity.fase_nombre,
      entity.fase_orden,
      TorneoTipo.fromJSON(entity.torneoTipo!),
      Torneo.fromJSON(entity.torneo!),
      entity.partidoList ? entity.partidoList.map((p) => Partido.fromJSON(p)) : [],
      entity.zonas ? entity.zonas.map((p) => TorneoZonaXFase.fromJSON(p)) : []
    );
  }

  toJSON(): FaseJSON {
    return {
      fase_id: this.getId(),
      fase_torid: this.getTorid(),
      fase_ttid: this.getTtid(),
      fase_cant_max_equipos: this.getCantMaxEquipos(),
      fase_cant_zonas: this.getCantZonas(),
      fase_nombre: this.getNombre(),
      fase_orden: this.getOrden(),
      torneoTipo: this.getTorneoTipo().toJSON(),
      torneo: null,
      partidoList: this.partidoList.map((p) => p.toJSON()),
      zonas: this.zonas.map((p) => p.toJSON()),
    };
  }

  getId(): string {
    return this.id;
  }

  getTorid(): string {
    return this.torid;
  }

  getTtid(): string {
    return this.ttid;
  }

  getCantMaxEquipos(): number {
    return this.cantMaxEquipos;
  }

  getOrden() {
    return this.orden;
  }

  setOrden(v: number) {
    this.orden = v;
  }

  setCantMaxEquipos(v: number) {
    this.cantMaxEquipos = v;
  }

  setPartidoList(v: Partido[]) {
    this.partidoList = v;
  }

  getCantZonas(): number {
    return this.cantZonas;
  }

  getZonas(): TorneoZonaXFase[] {
    return this.zonas;
  }

  getNombre(): string {
    return this.nombre;
  }

  getTorneoTipo(): TorneoTipo {
    return this.torneoTipo;
  }

  getTorneo(): Torneo {
    return this.torneo!;
  }

  getPartidoList(): Partido[] {
    return this.partidoList;
  }
}
